import { QuiltedHealthCodeSystems } from "@/fhir/enums/quilted-health";
import { Systems } from "@/fhir/enums/systems";

export const PLACE_OF_SERVICE_OPTIONS = [
  { value: "office", label: "Office" },
  { value: "home", label: "Home" },
  { value: "birth-center", label: "Birth Center" },
  { value: "telehealth-client-home", label: "Telehealth – Client Home" },
  { value: "hospital", label: "Hospital" },
  { value: "other", label: "Other" },
] as const;

export type PlaceOfServiceValue = (typeof PLACE_OF_SERVICE_OPTIONS)[number]["value"];

/**
 * The Place of Service each encounter location implies, keyed by `Encounter.class` system, then code.
 *
 * Covers every concept in the encounter location value set (LOINC LL3016-4 plus the Quilted Health
 * encounter-location CodeSystem).
 */
export const ENCOUNTER_CLASS_PLACE_OF_SERVICE: Record<
  string,
  Record<string, PlaceOfServiceValue>
> = {
  [Systems.LOINC]: {
    "LA21424-9": "office",
    "LA21427-2": "hospital",
    "LA21428-0": "home",
    "LA28895-3": "birth-center",
    "LA21429-8": "other",
  },
  [QuiltedHealthCodeSystems.EncounterLocation]: {
    "forms/encounters/location/virtual-visit": "telehealth-client-home",
    "forms/encounters/location/phone-call": "telehealth-client-home",
  },
};
